if (!customElements.get("storytelling-carousel")) {
  class StorytellingCarousel extends HTMLElement {
    constructor() {
      super();

      this.carousel = this
      this.carouselContainer = this.querySelector(".carousel-container");
      this.carouselItems = Array.from(this.querySelectorAll(".carousel-product"));
      this.carouselItemWidth = this.carouselItems[0].getBoundingClientRect().width;
      this.carouselActiveItem = null;
      this.carouselActiveMedia = null;
      this.leftArrow = this.querySelector(".left-arrow");
      this.rightArrow = this.querySelector(".right-arrow");
      this.displaceDistance = window.innerHeight * -1;
      this.windowHeight = window.innerHeight;
      this.scrollTop = window.scrollY - this.offsetTop;
      this.contentBottomContainer = this.closest(".carousel-content-block");
      this.headerHeightVar = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      this.headerHeight = String(this.headerHeightVar).replace('px', '');
      this.ticking = false;

      this.currentIndex = 0;
      this.prevIndex = 0;

      this.setCarouselMediaObserverOptions = {
        rootMargin: '50% 0% 50% 0%',
        threshold: 0
      }
    }

    connectedCallback() {

      this.initCarousel();

      this.CarouselMediaItems = this.querySelectorAll(".carousel-product__media video");

      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            this.setMedia(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, this.setCarouselMediaObserverOptions);

      if(this.CarouselMediaItems.length > 0) {
        this.CarouselMediaItems.forEach(item => {
          observer.observe(item);
        });
      }

      // resize event
      window.addEventListener("resize", () => {
        this.carouselItemWidth = this.carouselItems[0].getBoundingClientRect().width;
        this.scrollTop = window.scrollY - this.offsetTop;
      });

      setTimeout(() => {
        this.calcScrollTop();
        this.displaceActiveProductMedia();
      }, 500);
    }

    setMedia(media) {
      if (media) {
        if (!isIE11()) {
          const webmUrl = media.dataset.webmFormat;
          const movUrl = media.dataset.movFormat;

          if(supportsHEVCAlpha() == false && iOS() == true) {
            media.src = movUrl;
          } else if(supportsHEVCAlpha() == false && iOS() == false) {
            media.src = webmUrl;
          } else {
            media.src = movUrl;
          }
        }
      }
    }

    initCarousel() {
      this.cloneItems();

      this.leftArrow.addEventListener("click", this.onLeftArrowClick.bind(this));
      this.rightArrow.addEventListener("click", this.onRightArrowClick.bind(this));
      // attach mouse events
      this.carouselContainer.addEventListener("mousedown", this.dragStartEvent.bind(this));
      this.carouselContainer.addEventListener("mouseup", this.dragEndEvent.bind(this));
      this.carouselContainer.addEventListener("mouseleave", this.dragEndEvent.bind(this));
      this.carouselContainer.addEventListener("mousemove", this.dragMoveEvent.bind(this));
      // attach touch events
      this.carouselContainer.addEventListener("touchstart", this.touchStartEvent.bind(this));
      this.carouselContainer.addEventListener("touchend", this.dragEndEvent.bind(this));
      this.carouselContainer.addEventListener("touchmove", this.touchMoveEvent.bind(this));

      window.addEventListener('scroll', this.onScroll.bind(this), false);

    }

    onScroll() {
      this.ticking = this.ticking || requestAnimationFrame(() => {this.calcScrollTop()});
    }

    calcScrollTop() {
        this.ticking = false;
        const scrollTop = window.scrollY - this.contentBottomContainer.offsetTop - this.headerHeight;
        if(scrollTop > 0 && scrollTop < this.windowHeight) {
          this.carouselActiveMedia.style.transform = `translate3d(0, ${this.displaceDistance + scrollTop}px, 0)`;
        } else if (scrollTop >= this.windowHeight) {
          this.carouselActiveMedia.style.transform = `translate3d(0, ${this.displaceDistance + this.windowHeight}px, 0)`;
        } else {
          this.carouselActiveMedia.style.transform = `translate3d(0, ${this.displaceDistance}px, 0)`;
        }
        if(scrollTop > 0 && scrollTop < this.windowHeight - 50) {
          this.disableCarousel = true;
          this.classList.add("disable-carousel");
        } else {
          this.disableCarousel = false;
          this.classList.remove("disable-carousel");
        }
    }

    displaceActiveProductMedia() {
      this.ticking = false;
      this.carouselActiveMedia.style.transform = `translate3d(0, ${this.displaceDistance}px, 0)`;
    }

    updateActiveItem(direction){
      this.currentActiveItem = this.querySelector(".carousel-product.active");
      this.currentActiveItem.classList.remove("active");
      if(direction === "right"){
        this.currentActiveItem.nextElementSibling.classList.add("active");
      }
      if(direction === "left"){
        this.currentActiveItem.previousElementSibling.classList.add("active");
      }
      this.carouselActiveItem = this.querySelector(".carousel-product.active");
      this.carouselActiveMedia = this.querySelector(".carousel-product.active .carousel-product__media video") || this.querySelector(".carousel-product.active .carousel-product__media img");
    }

    moveLeft() {
      if(this.disableCarousel) return;
      this.isMoving = true;
      this.prevIndex = this.currentIndex;
      this.currentIndex = (this.currentIndex - 1 + this.carouselItems.length) % this.carouselItems.length;
      this.carouselContainer.style.transform = `translateX(-${this.carouselItemWidth}px)`;

      this.updateActiveItem("left");

      this.carouselContainer.insertBefore(this.carouselItems[this.currentIndex], this.carouselContainer.firstChild);

      setTimeout(() => {
        this.carouselContainer.style.transform = "";
        this.carouselContainer.classList.add("sliding-transition");
      }, 10);

      setTimeout(() => {
        // By removing the transition class, we ensure that the transition only occurs when we want it to and that we have full control over the carousel's movement.
        this.carouselContainer.classList.remove("sliding-transition");
        this.isMoving = false;
      }, 490);

      // this.carouselItems = this.querySelectorAll(".carousel-product");
    }

    moveRight() {
      if(this.disableCarousel) return;
      this.isMoving = true;
      this.carouselContainer.classList.add("sliding-transition");
      this.prevIndex = this.currentIndex;
      this.currentIndex = (this.currentIndex + 1 ) % this.carouselItems.length;
      this.carouselContainer.style.transform = `translateX(-${this.carouselItemWidth}px)`;

      this.updateActiveItem("right");

      setTimeout(() => {
        this.carouselContainer.appendChild(this.carouselItems[this.prevIndex]);
        this.carouselContainer.classList.remove("sliding-transition");
        this.carouselContainer.style.transform = "";
        this.isMoving = false;
      }, 500);
    }

    onRightArrowClick() {
      if(this.isMoving) return;
      this.moveRight();
    }

    onLeftArrowClick() {
      if(this.isMoving) return;
      this.moveLeft();
    }

    dragStartEvent(e) {
      this.dragging = true;
      this.dragStart = e.clientX;
      this.dragInitialStart = e.clientX
      this.carouselContainer.style.cursor = "grabbing";
    }

    dragEndEvent(e) {
      if(this.isMoving) return;
      if(this.dragDelta < 0 && Math.abs(this.dragDelta) > 50){
        this.moveRight();
      }
      if(this.dragDelta > 0 && Math.abs(this.dragDelta) > 50){
        this.moveLeft();
      }
      this.dragging = false;
      this.dragStart = null;
      this.dragDelta = 0;
      this.carouselContainer.style.cursor = "grab";
    }

    dragMoveEvent(e) {
      requestAnimationFrame(() => {
        if (this.dragging) {
          // calculate how much user dragged mouse
          this.dragDelta = e.clientX - this.dragStart;
        }
      });
    }

    touchStartEvent(e) {
      this.dragging = true;
      this.dragStart = e.touches[0].clientX;
      this.dragInitialStart = e.touches[0].clientX
      this.carouselContainer.style.cursor = "grabbing";
    }

    touchMoveEvent(e) {
      requestAnimationFrame(() => {
        if (this.dragging) {
          // calculate how much user dragged mouse
          this.dragDelta = e.touches[0].clientX - this.dragStart;
        }
      });
    }

    cloneItems() {

      // clone all items to the front and back
      this.carouselItems.forEach((item, index) => {
        let clone = item.cloneNode(true);
        clone.classList.remove("active");
        this.carouselContainer.appendChild(clone);
      });

      // translate so the active element is in the middle
      // this.carouselContainer.style.transform = `translateX(-${this.carouselItemWidth * this.carouselItems.length}px)`;

      this.carouselItems = Array.from(this.querySelectorAll(".carousel-product"));
      this.carouselItems[1].classList.add("active");

      this.carouselActiveItem = this.querySelector(".carousel-product.active");
      this.carouselActiveMedia = this.carouselActiveItem.querySelector(".carousel-product__media video") || this.carouselActiveItem.querySelector(".carousel-product__media img");
    }
  }
  customElements.define("storytelling-carousel", StorytellingCarousel);
}

// Scrollable product (no carousel)
if (!customElements.get("scrollable-product")) {
  class ScrollableProduct extends HTMLElement {
    constructor() {
      super();

      this.carouselItem = this.querySelector(".carousel-product");
      this.carouselActiveMedia = this.querySelector(".carousel-product.active .carousel-product__media video") || this.querySelector(".carousel-product.active .carousel-product__media img");
      this.displaceDistance = window.innerHeight * -1;
      this.windowHeight = window.innerHeight;
      this.scrollTop = window.scrollY - this.offsetTop;
      this.contentBottomContainer = this.closest(".carousel-content-block");
      this.headerHeightVar = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      this.headerHeight = String(this.headerHeightVar).replace('px', '');

      this.setScrollableProductObserverOptions = {
        rootMargin: '50% 0% 50% 0%',
        threshold: 0
      }
    }

    connectedCallback() {
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            this.setMedia(entry.target);
            observer.unobserve(this);
          }
        });
      }, this.setScrollableProductObserverOptions);

      if(this.carouselActiveMedia && this.carouselActiveMedia.tagName === "VIDEO") {
        observer.observe( this.carouselActiveMedia);
      }

      document.addEventListener("scroll", this.calcScrollTop.bind(this));
      this.displaceActiveProductMedia();
      this.calcScrollTop();
    }

    setMedia(media) {
      if (media) {
        if (!isIE11()) {
          const webmUrl = media.dataset.webmFormat;
          const movUrl = media.dataset.movFormat;

          if(supportsHEVCAlpha() == false && iOS() == true) {
            media.src = movUrl;
          } else if(supportsHEVCAlpha() == false && iOS() == false) {
            media.src = webmUrl;
          } else {
            media.src = movUrl;
          }
        }
      }
    }

    calcScrollTop() {
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY - this.contentBottomContainer.offsetTop - this.headerHeight;
        if(scrollTop > 0 && scrollTop < this.windowHeight) {
          this.carouselActiveMedia.style.transform = `translate3d(0, ${this.displaceDistance + scrollTop}px, 0)`;
        }
        if(scrollTop > 0 && scrollTop < this.windowHeight - 50) {
          this.disableCarousel = true;
        } else {
          this.disableCarousel = false;
        }
      });
    }

    displaceActiveProductMedia() {
      this.carouselActiveMedia.style.transform = `translate3d(0, ${this.displaceDistance}px, 0)`;
    }
  }
  customElements.define("scrollable-product", ScrollableProduct);
}




// Scrollable video
if (!customElements.get("scrollable-video")) {
  class ScrollableVideo extends HTMLElement {
    constructor() {
      super();
      this.headerHeightVar = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      this.headerHeight = String(this.headerHeightVar).replace('px', '');
      this.sectionEl = document.querySelector(".storytelling");
      this.video = this.querySelector("video");
      this.frameNumber = 0;
      this.scrollTop = window.scrollY - this.sectionEl.offsetTop;
      this.videoDuration = this.video.duration;
      this.scrollDistance = this.offsetHeight - this.video.offsetHeight - this.headerHeight;
      this.seeking = false;
      this.timeUpdated = true;

      this.webmUrl = this.video.dataset.webmFormat;
      this.movUrl = this.video.dataset.movFormat;
      this.isTiedToScroll = this.video.dataset.tiedToScroll === "true" ? true : false;

      this.setScrollableVideoObserverOptions = {
        rootMargin: '50% 0% 50% 0%',
        threshold: 0
      }

    }

    connectedCallback() {
      if(this.isTiedToScroll === false) {
        this.setVideoUrl();
        return;
      }
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            this.setVideoUrl(entry.target);
            observer.unobserve(this);
          }
        });
      }, this.setScrollableVideoObserverOptions);

      observer.observe(this.video);

      if(this.video) {
        this.video.addEventListener("loadeddata", this.initVideo.bind(this));
      }
    }

    setVideoUrl() {
      if (!isIE11()) {
        if(supportsHEVCAlpha() == false && iOS() == true) {
          this.video.src = this.movUrl;
        } else if(supportsHEVCAlpha() == false && iOS() == false) {
          this.video.src = this.webmUrl;
        } else {
          this.video.src = this.movUrl;
        }
      }
    }

    initVideo() {
      this.video.pause();
      this.scrollPlayVideo();
      window.addEventListener("scroll", this.scrollPlayVideo.bind(this));

      this.video.addEventListener("seeking", () => {
        this.seeking = true;
      });
      this.video.addEventListener("seeked", () => {
        this.seeking = false;
      });
    }

    scrollPlayVideo() {
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY - this.sectionEl.offsetTop;

        let percantage = scrollTop / this.scrollDistance;
        percantage = Math.max(0, percantage);
        percantage = Math.min(percantage, 1);
        let videoTimeStamp = percantage * this.video.duration;

        // videoTimeStamp to 1 decimal points
        videoTimeStamp = Math.round(videoTimeStamp * 10) / 10;

        if(this.video.duration > 0 && scrollTop <= this.scrollDistance && !this.seeking) {
          this.video.currentTime = videoTimeStamp;
          this.video.pause();
        }
      })
    }

  }
  customElements.define("scrollable-video", ScrollableVideo);
}

// Scrollable video
if (!customElements.get("marquees-wrapper")) {
  class MarqueesWrapper extends HTMLElement {
    constructor() {
      super();
      this.fullScreenLogo = document.querySelector(".full-screen-logo")
      this.headerHeightVar = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      this.headerHeight = String(this.headerHeightVar).replace('px', '');
    }

    connectedCallback() {
      if(this.fullScreenLogo) {
        this.parentElement.style.paddingTop = `${this.fullScreenLogo.offsetHeight + parseInt(this.headerHeight) + 40}px`;
      } else {
        this.parentElement.style.paddingTop = `${parseInt(this.headerHeight) + 40}px`;
      }

    }


  }
  customElements.define("marquees-wrapper", MarqueesWrapper);
}